<template>
  <li
    class="calico-menu-item"
    :class="{ address, select }"
  >
    <div
      class="menu-item"
      :data-active="isActive" 
      :class="{ disabled }"
      :disabled="disabled"
      @click="$emit('update:modelValue', value)"
    >
      <span class="menu-label">
        <slot />
      </span>
      <i
        v-if="select && modelValue.includes(value)"
        class="bi bi-check-circle-fill text-active"
      />
    </div>
  </li>
</template>

<script>
export default {
  name: "CalicoMenuItem",
  props: {
    value: { type: [String, Number], required: true },
    modelValue: { type: [String, Number, Array], default: null },
    disabled: { type: Boolean, default: false },
    address: { type: Boolean, default: false },
    select: { type: Boolean, default: false },
  },
  computed: {
    isActive() {
      if (this.select) {
        return Array.isArray(this.modelValue) && this.modelValue.includes(this.value)
          ? "true"
          : "false";
      }
      return this.modelValue === this.value ? "true" : "false";
    },
  },
};
</script>

<style lang="scss" scoped>
.calico-menu-item {
  list-style: none;

  .menu-item {
    @include inline-space($space-small);
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    padding: $space-small;
    background-color: $color-white;
    border-bottom: 1px solid $color-neutral;
    text-align: left;

    .calico-menu-item:last-child .menu-item {
  border-bottom: none;
}


    &:not(.disabled):hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    &.disabled {
      pointer-events: none;
      color: $color-neutral-light;
    }

    &:not(.disabled):active {
      background-color: rgba(0, 0, 0, 0.25);
      border-color: $color-black;
    }
  }

  &:last-of-type .menu-item {
    border-bottom: none;
  }


  &.address {
  .menu-item {
    .menu-label {
      :deep(.address-content) {
        @include stack-space($space-xsmall);
        align-items: flex-start;
      }
    }
  }
}

  &.select {
    .menu-item {
      &[data-active="true"] {
        background-color: $color-white;
      }
    }
    .menu-label {
      color: $color-black;
    }
    .menu-item[data-active="true"] .menu-label {
      color: $color-green-dark;
    }
  }

  .text-active {
    color: $color-green-dark;
  }
  
  .bi {
    font-size: $icon-small;
  }
  
  .menu-label {
    user-select: none;
    font-weight: $font-weight-bold;
    color: $color-black;
  }
}
</style>
